import { Component } from '@angular/core';


@Component({
	selector: 'button-container',
	templateUrl: './button-container.widget.html',
	styleUrls: ['button-container.widget.scss'],
})
export class ButtonContainerWidget {
}
